import type { FindingOut } from '@/api/types';
import { tagsFor, type Tag } from '@/lib/finding-tags';

/** Pill row rendered on every finding-bearing surface (review queue card,
 *  audit-log table, supplier drawer). Currently surfaces only the currency
 *  tag for foreign-source findings — CAD findings render no pill so the
 *  signal stays high.
 */
export function FindingTags({ finding }: { finding: FindingOut }) {
  const tags = tagsFor(finding);
  if (tags.length === 0) return null;
  return (
    <span className="flex flex-wrap items-center gap-1">
      {tags.map((t) => (
        <TagPill key={t.id} tag={t} />
      ))}
    </span>
  );
}

function TagPill({ tag }: { tag: Tag }) {
  return (
    <span
      title={tag.tooltip}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${tag.className}`}
    >
      <span aria-hidden="true">{tag.emoji}</span>
      <span>{tag.label}</span>
    </span>
  );
}
